//import Vue from 'vue'

import URI from 'urijs';
import {gsap, Power3, ScrollToPlugin} from 'gsap';
//import ScrollToPlugin from 'gsap/umd/ScrollToPlugin';
const scrollPlugin = ScrollToPlugin;

const AnchorPlugin = {
  install (Vue, options) {

    Vue.prototype.$_onLink = (e) => {
      e.preventDefault();

      const hash = this.$_getHash(e.target);

      if (hash) {
        //location.href = `/campaign/klv/?anchor=${hash}`;
      }
    };

    Vue.prototype.$_gotoAnchor = (hash) => {
      if (hash) {

        let adjust = 0;
        if (hash.indexOf('recipe-') === 0) {
          adjust = 100;
        }

        /*const el = document.getElementById(this.domList[hash]);
        const posY = AnyStore.getOffsetTop(el).top - adjust;

        TweenMax.to(window, 0.5, {
          scrollTo: {y: posY, autoKill: false},
          ease: Power3.easeInOut
        });*/
      }
    };

    Vue.prototype.$_getHash = (el) => {
      const tagname = el.tagName.toLowerCase();
      let hash = '';

      if (tagname === 'a') {
        hash = el.hash.replace('#', '');
      } else {
        //hash = el.querySelector('a').hash.replace('#', '');
        let parent = el.parentNode;

        while (parent && parent != document.body && parent.tagName.toLocaleLowerCase() != 'a') {
          parent = el.parentNode;
        }

        if (parent) {
          hash = parent.hash.replace('#', '');
        }
      }

      return hash;
    };

    Vue.prototype.$_getOffset = (el) => {
      let targetY = el.offsetTop;
      let parent = el.offsetParent;
      while (parent && parent != document.body) {
        targetY += parent.offsetTop;
        parent = parent.offsetParent;
      }
      return {top: targetY, parent: parent};
    };

    Vue.mixin({
      data() {
        return {}
      },
      computed: {
      },
      methods: {
        $_onAnchor(e) {
          e.preventDefault();
          const hash = this.$_getHash(e.target);
          let posY = 0, adjust = 0;
          if (hash === 'message') {
            posY = this.$_getOffset(document.getElementById('p-topMessage')).top;
            adjust = 80;
          } else if (hash === 'about') {
            posY = this.$_getOffset(document.getElementById('p-topAbout')).top;
            adjust = 80;
          } else if (hash === 'features') {
            posY = this.$_getOffset(document.getElementById('p-topFeature')).top;
            adjust = 80;
          } else if (hash === 'special') {
            posY = this.$_getOffset(document.getElementById('p-topSpecial')).top;
            adjust = 80;
          } else if (hash === 'product') {
            posY = this.$_getOffset(document.getElementById('p-topProduct')).top;
            adjust = 80;

          // プロダクト
          } else if (hash === 'concept') {
            posY = this.$_getOffset(document.getElementById('p-productConcept')).top;
            adjust = 80;
          } else if (hash === 'product-features') {
            posY = this.$_getOffset(document.getElementById('p-productFeature')).top;
            adjust = 80;
          } else if (hash === 'lineup') {
            posY = this.$_getOffset(document.getElementById('p-productLineup')).top;
            adjust = 80;

          // その他
          } else if (hash === 'feature1') {
            posY = this.$_getOffset(document.getElementById('p-feature1')).top;
            adjust = 80;
          } else if (hash === 'feature2') {
            posY = this.$_getOffset(document.getElementById('p-feature2')).top;
            adjust = 80;
          } else if (hash === 'feature3') {
            posY = this.$_getOffset(document.getElementById('p-feature3')).top;
            adjust = 80;
          } else if (hash === 'feature4') {
            posY = this.$_getOffset(document.getElementById('p-feature4')).top;
            adjust = 80;
          } else if (hash === 'feature5') {
            posY = this.$_getOffset(document.getElementById('p-feature5')).top;
            adjust = 80;
          }

          this.$_gotoScroll(posY - adjust);
        },
        $_gotoScroll(posY) {
          gsap.to(window, {duration: 0.8, scrollTo: {y: posY, autoKill: false}, ease: Power3.easeInOut});
        },
        $_getUrlAnchor() {
          const uri = new URI(location.search);
          const qs = uri.query(true);

          if (qs.anchor) {
            const posY = this.$_getOffset(document.getElementById(qs.anchor)).top;
            const adjust = 80;

            this.$_gotoScroll(posY - adjust);
          }
        }
      }
    });
  }
};

export default AnchorPlugin